<template>
    <div>
        <template v-if="loadingProfile">
            <div class="div__loading">
                <loader />
            </div>
        </template>
        <template v-else>
            <main>
                <section class="section">
                    <div class="container alumni__main">
                        <h4 class="section__title section__title--left">Alumni Profile</h4>
                        <div class="alumni">
                            <div class="alumni__wrapper">
                                <img v-if="profile.avatar" class="post__img" :src="profile.avatar" alt="">
                                <img v-else class="post__img" src="../../assets/img/profile.jpg" alt="">
                                <div>
                                    <h5 class="bold">{{ fullName }}</h5>
                                    <span>{{ profile.email }}</span>
                                </div>
                            </div>
                            
                            <div class="badges">
                                <h5 class="bold">Badge</h5>
                                <div v-if="profile.badges" class="badges__wrapper">
                                    <div class="badges__item">
                                        <span>
                                            <svg width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30 60a30 30 0 1 0 0-60 30 30 0 0 0 0 60z" fill="#A0BF19"/>
                                                <path d="M52.28 17.6c-.94-2.44-2.87-2.05-4.95-1.64-1.25.26-6.8 1.88-15.57 11.14a74.12 74.12 0 0 0-7.62 9.23 48.43 48.43 0 0 0-3.24-3.62 46.78 46.78 0 0 0-7.73-6.13 3.55 3.55 0 0 0-3.7 6.06c.03.02 3.45 2.14 6.4 5.1 3.02 3.01 5.75 7.1 5.78 7.13a3.55 3.55 0 0 0 6.4-1.11c.01-.03 1.42-3.93 8.87-11.77 5.99-6.33 9.99-8.34 11.37-8.9h.04l.13-.06a4.32 4.32 0 0 1 .27-.1v-.02c.64-.28 1.84-.8 1.87-.8 1.8-.74 2.39-2.69 1.68-4.5z" fill="#C0DD19"/>
                                            </svg>
                                        </span>
                                        verified
                                    </div>
                                </div>
                                <div style="padding-top: 20px">
                                    <h5>No badges earned yet</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </template>
    </div>
</template>

<script>
import { getAlumniProfile } from '../../utils/api/alumni';
import Loader from '../../components/Loader';

export default {
	name: 'AlumniProfile',
	data() {
		return {
			itemData: {},
			loadingProfile: true,
			profileLoaded: false,
			profile: {}
		};
	},
	created() {
		if (this.$session.get('category') === 'employer') {
			this.$router.push('/jobs');
		}
	},
	mounted() {
		this.getAlumniProfile();
	},
	methods: {
		getAlumniProfile() {
			getAlumniProfile(this.$route.params.id)
				.then((response) => {
					if (response.status === 200) {
						this.itemData = response.data.data;
						this.profile = response.data.data.user;
						this.profileLoaded = true;
						return true;
					}
					this.profileLoaded = false;
					return false;
				}).catch((error) => {
					this.profileLoaded = false;
					return false;
				}).finally(() => {
					this.loadingProfile = false;
				});
		}
	},
	components: {
		Loader
	},
	computed: {
		fullName() {
			return `${this.profile.fname} ${this.profile.lname}`;
		}
	}
};
</script>

<style scoped>
.div__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
